<template>
	<section>
		<div class="mb-4">
			<h2 class="font-italic mb-2">
				Welcome
			</h2>
			<span>{{ user }}</span>
		</div>		
		<h3 class="font-italic">
			First time here?<br/>
			Please set your password
		</h3>
		<form v-on:submit.prevent="setPassword">
			<div class="form-group">
				<label for="new-password" class="sr-only">Password</label>
				<input type="password" class="form-control" id="new-password" placeholder="Password" v-model="password" :class="{ 'is-invalid': $v.password.$error }"/>
				<div class="invalid-feedback" v-if="!$v.password.required">Field is required</div>
				<div class="invalid-feedback" v-if="!$v.password.minLength">Password must have at least {{ $v.password.$params.minLength.min }} letters.</div>
			</div>
			<div class="form-group">
				<label for="confirm-password" class="sr-only">Confirm password</label>
				<input type="password" class="form-control" id="confirm-password" placeholder="Confirm password" v-model="password_confirmation" :class="{ 'is-invalid': $v.password_confirmation.$error }"/>
				<div class="invalid-feedback" v-if="!$v.password_confirmation.required">Field is required</div>
				<div class="invalid-feedback" v-if="!$v.password_confirmation.sameAsPassword">Passwords must be identical.</div>
			</div>
			<div class="row-btn">
				<button type="submit" class="btn btn-primary">Confirm</button>
			</div>											
		</form>		
	</section>					
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import api from '../http/api.js';
import { required, sameAs, minLength } from 'vuelidate/lib/validators'


export default {
  name: 'SetPassword',
  /*components: {
    HelloWorld
  }*/
  data: function () {
    return {
		password: '',
		password_confirmation: '',
    }
  },
  validations: {
        password: {
			required,
			minLength: minLength(8)
        },
        password_confirmation: {
			required,
			sameAsPassword: sameAs('password')
        }
    },
  computed:{
		user: function(){
			return atob(this.$route.params.user)
		}
  },
  methods: {
	setPassword: function(){
		this.$v.$touch()
        if (this.$v.$invalid) {
            return false;
		}
		
		var url = '/v1/password/'+ this.$route.params.verificationToken;
		var v = this;
		api.post(url, {
			password: this.password,
			password_confirmation: this.password_confirmation,
			verification_token: this.$route.params.verificationToken 
		})
		.then((response) => {
			var username = response.data.data.email;
			var password = this.password
			var privacy = response.data.data.privacy;

			this.$store.dispatch('login', { username, password })
				.then(() => {
					if(privacy == null){
						this.$router.push('/privacy');
					} else {
						this.$router.push('/');
					}
				});
		}, (err) => {
			v.$emit('show-message', {
				type: 'danger',
				text: err.response.data.message
			});
		});
	},
  }
}
</script>
